export const VERSION = "v3.2.1";

export const DEFAULT_ACCOUNT = "abra";

export const LOGIN_URL_GOOGLE = "https://api.spottertech.com/login/googleLogin";
export const LOGIN_URL_3P = "https://api.spottertech.com/login";

export const domainMap = {
    spottertech: {
        name: "Spotter",
        host: "https://v3.spottertech.com",
        account: "abra",
        logoPath: "/images/spotter.png",
        logoTransparent: true,
        faviconPath: "/images/spotter-ico.png",
        themeVars: {
            "--primary-color": "#2563eb",
            "--secondary-color": "#1d4ed8",
            "--page-bg-start": "#eef7ff",
            "--page-bg-end": "#d8e1e8",
            "--panel-bg": "#ffffff",
            "--text-muted": "#98a2b3",
            "--input-border": "#d0d5dd",
            "--shadow-color": "rgba(0, 0, 0, 0.12)",
            "--error-bg": "#fef3f2",
            "--error-border": "#fda29b",
            "--error-text": "#b42318",
        },
    },
    wellguardtechnologies: {
        name: "Wellguard Technologies",
        host: "https://bo.wellguardtechnologies.com",
        account: "wellguard",
        logoPath: "/images/wg-light-720.jpg",
        logoTransparent: false,
        faviconPath: "/images/wg-ico-transparent-32.png",
        themeVars: {
            "--primary-color": "#9e2081",
            "--secondary-color": "#7f1968",
            "--page-bg-start": "#f7eef5",
            "--page-bg-end": "#e4d7e1",
            "--panel-bg": "#ffffff",
            "--text-muted": "#7a6d76",
            "--input-border": "#d8c9d3",
            "--shadow-color": "rgba(78, 24, 65, 0.14)",
            "--error-bg": "#fef3f2",
            "--error-border": "#fecdca",
            "--error-text": "#b42318",
        },
    },
};

export const domainThemes = {
    spottertech: {
        "--primary-color": "white",
        "--secondary-color": "#cfd8dc",
    },
    wellguardtechnologies: {
        "--primary-color": "#d3d3d3ff",
        "--secondary-color": "white",
    },
};
